import { useContext, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import "../../Style/NewCompanyStyle.scss";
import "../../Style/NewLicensModern.scss";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import axios from "axios";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import { errorAlert, handleSuccess } from "../../Components/Alerts";
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
// import {
//   LICENSE_TYPES,
//   PAYMENT_STATUS,
//   LICENSE_STATUS,
// } from "../../OtherData/LicenseData";
import { AddActionsButton } from "../../Components/AddElementsButton";
import { FaTimes } from "react-icons/fa";
import { getSystemPackage } from "../../GetData/SystemPackage";
import { getSystemModules } from "../../GetData/SystemModules";
import { getLicenseStatus } from "../../GetData/LicenseStatus";
import { getSystemLicenseTypes } from "../../GetData/LicenseType";
import { getLicensePaymentStatus } from "../../GetData/LicensePaymentType";

function toIsoDate(value) {
  if (!value) {
    return "";
  }

  const raw = String(value);
  const match = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (match) {
    return `${match[1]}-${match[2]}-${match[3]}`;
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return "";
  }

  const year = parsed.getFullYear();
  const month = String(parsed.getMonth() + 1).padStart(2, "0");
  const day = String(parsed.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function shiftIsoDateYear(value, yearsToShift = 1) {
  const iso = toIsoDate(value);
  if (!iso) {
    return "";
  }

  const [yearStr, monthStr, dayStr] = iso.split("-");
  const year = Number(yearStr);
  const month = Number(monthStr);
  const day = Number(dayStr);

  if (!Number.isInteger(year) || !Number.isInteger(month) || !Number.isInteger(day)) {
    return iso;
  }

  const targetYear = year + yearsToShift;
  const daysInTargetMonth = new Date(targetYear, month, 0).getDate();
  const safeDay = Math.min(day, daysInTargetMonth);

  return `${targetYear}-${String(month).padStart(2, "0")}-${String(safeDay).padStart(2, "0")}`;
}

export default function NewLicens() {
  const headers = authHeader();
  const history = useHistory();
  const location = useLocation();
  // const year = new Date().getFullYear();
  const { fiscalYear } = useContext(FiscalYearContext);

  const query = new URLSearchParams(location.search || "");
  const statePayload = location.state || {};

  let storagePayload = null;
  try {
    const raw = sessionStorage.getItem("relicenseContext");
    storagePayload = raw ? JSON.parse(raw) : null;
  } catch (error) {
    storagePayload = null;
  }

  const queryRelicense = query.get("relicense") === "1";
  const stateRelicense = Boolean(statePayload?.isRelicense);
  const storageRelicense = Boolean(storagePayload?.isRelicense);
  const isRelicenseIntent = stateRelicense || queryRelicense || storageRelicense;

  const resolvedCompanyId =
    statePayload?.companyId ||
    statePayload?.CompanyID ||
    query.get("companyId") ||
    query.get("CompanyID") ||
    (isRelicenseIntent ? storagePayload?.companyId : null);

  const resolvedIdentificationNumber =
    statePayload?.identificationNumber ||
    statePayload?.IdentificationNumber ||
    query.get("identificationNumber") ||
    query.get("IdentificationNumber") ||
    (isRelicenseIntent ? storagePayload?.identificationNumber : "") ||
    "";

  const resolvedCompanyName =
    statePayload?.companyName ||
    statePayload?.CompanyName ||
    query.get("companyName") ||
    query.get("CompanyName") ||
    (isRelicenseIntent ? storagePayload?.companyName : "") ||
    "";

  const querySeed = {
    LicenseTypeID: query.get("licenseTypeId") || null,
    PackageID: query.get("packageId") || null,
    Status: query.get("statusId") || null,
    PaymentStatus: query.get("paymentStatusId") || null,
    StartDate: query.get("startDate") || null,
    EndDate: query.get("endDate") || null,
    Comment: query.get("comment") || "",
  };

  const hasQuerySeed = Boolean(
    querySeed.LicenseTypeID ||
    querySeed.PackageID ||
    querySeed.Status ||
    querySeed.PaymentStatus ||
    querySeed.StartDate ||
    querySeed.EndDate ||
    querySeed.Comment
  );

  const resolvedLicenseSeed =
    statePayload?.licenseSeed ||
    (hasQuerySeed ? querySeed : null) ||
    (isRelicenseIntent ? storagePayload?.licenseSeed : null) ||
    null;

  const preselectedCompany = resolvedCompanyId
    ? {
        CompanyID: resolvedCompanyId,
        IdentificationNumber: resolvedIdentificationNumber,
        CompanyName: resolvedCompanyName,
      }
    : null;
  const isRelicenseMode = Boolean((isRelicenseIntent || resolvedCompanyId) && preselectedCompany?.CompanyID);
  const [module, setModule] = useState([]);

  const [disableForm, setDisableForm] = useState(false);
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  // Company states
  const [identificationNumber, setIdentificationNumber] = useState("");

  // License states
  const [licenseTypeID, setLicenseTypeID] = useState();
  const [packageID, setPackageID] = useState("");
  const [startDate, setStartDate] = useState(new Date().toISOString().slice(0, 10));
  const [endDate, setEndDate] = useState("");
  const [statusID, setStatusID] = useState("");
  const [paymentStatusID, setPaymentStatusID] = useState("");
  const [licenseComment, setLicenseComment] = useState("");

  const [pack, setPack] = useState([]);
  const [company, setCompany] = useState([]);

  const [accountantUser, setAccountantUser] = useState([]);

  const [accountantUserID, setAccountantUserID] = useState("");
  const [ipAddress, setIpAddress] = useState("");
  const [userComment, setUserComment] = useState("");

  const [licenseTypes, setLicenseTypes] = useState([]);
  const [licensesStatus, setLicensesStatus] = useState([]);
  const [licensePaymentType, setLicensePaymentType] = useState([]);
  const [latestLicensePrefilled, setLatestLicensePrefilled] = useState(false);
  const [modulesPrefilledForCompanyId, setModulesPrefilledForCompanyId] = useState(null);

  //Pjesa per select input field city
  const [companyName, setCompanyName] = useState("");
  const handleAutocompleteChangeCompany = (event, value) => {
    if (value && value.CompanyID) {
      setIdentificationNumber(value.IdentificationNumber);
      setCompanyName(value);
    } else {
      // Në rast se vlera është pastruar
      setIdentificationNumber(""); // Vendos vlerën e ArticleID në null
    }
  };

  const defaultPropsCompany = {
    options: company,
    getOptionLabel: (option) =>
      `${option.IdentificationNumber} - ${option.CompanyName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.IdentificationNumber}
            <br />
            {option.CompanyName}{" "}
          </span>
        </li>
      </>
    ),
  };

  // const completeData = (id) => {
  //   if (id === 4) {
  //     setStatusID(4);
  //     setPaymentStatusID(4);
  //   } else if (id === 5) {
  //     setStatusID(5);
  //     setPaymentStatusID(5);
  //   }
  // };

  //Pjesa per select input field licenseType
  const [licenseType, setLiceseType] = useState(null);
  const handleAutocompleteChangeLicenseType = (event, value) => {
    if (value && value.DurationTypeID) {
      setLicenseTypeID(value.DurationTypeID);
      setLiceseType(value);
      // kalkulo endDate automatikisht
      const calculatedEnd = calculateEndDate(value.DurationDays);
      setEndDate(calculatedEnd);
      // completeData(value.DurationTypeID);
    } else {
      // nëse pastrohet
      setLicenseTypeID("");
      setLiceseType(null);
      setEndDate("");
    }
  };

  const defaultPropsLicenseType = {
    options: licenseTypes,
    getOptionLabel: (option) => `${option.DurationName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.DurationName}
            <br />
          </span>
        </li>
      </>
    ),
  };

  //Pjesa per select input field licenseStatus
  const [licenseStatus, setLiceseStatus] = useState(null);
  const handleAutocompleteChangeLicenseStatus = (event, value) => {
    if (value && value.LicenseStatusID) {
      setStatusID(value.LicenseStatusID);
      setLiceseStatus(value);
    } else {
      // Në rast se vlera është pastruar
      setStatusID(""); // Vendos vlerën e ArticleID në null
    }
  };

  const defaultPropsLicenseStatus = {
    options: licensesStatus,
    getOptionLabel: (option) => `${option.StatusName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.StatusName}
            <br />
          </span>
        </li>
      </>
    ),
  };

  //Pjesa per select input field paymentStatus
  const [paymentStatus, setPaymentStatus] = useState("");
  const handleAutocompleteChangePaymentStatus = (event, value) => {
    if (value && value.PaymentStatusID) {
      setPaymentStatusID(value.PaymentStatusID);
      setPaymentStatus(value);
    } else {
      // Në rast se vlera është pastruar
      setPaymentStatusID(""); // Vendos vlerën e ArticleID në null
    }
  };

  const defaultPropsPaymentStatus = {
    options: licensePaymentType,
    getOptionLabel: (option) => `${option.StatusName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.StatusName}
            <br />
          </span>
        </li>
      </>
    ),
  };

  //Pjesa per select input field pack
  const [packageType, setPackageType] = useState(null);
  const [packageField, setPackageField] = useState(null);
  const handleAutocompleteChangePackageType = (event, value) => {
    if (value && value.PackageID) {
      setPackageID(value.PackageID);
      setPackageType(value.PackageName);
      setPackageField(value);
    } else {
      // Në rast se vlera është pastruar
      setPackageID("");
      setPackageType(null);
      setPackageField(null);
    }
  };

  const defaultPropsPackageType = {
    options: pack,
    getOptionLabel: (option) => `${option.PackageName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.PackageName}
            <br />
          </span>
        </li>
      </>
    ),
  };

  //Pjesa per select input field module
  const [moduleType, setModuleType] = useState([]);
  const [moduleField, setModuleField] = useState([]);
  const [moduleIDs, setModuleIDs] = useState([]);
  const handleToggleModule = (moduleId) => {
    const normalizedId = Number(moduleId);
    if (!Number.isInteger(normalizedId) || normalizedId <= 0) {
      return;
    }

    setModuleIDs((prev) => {
      const current = Array.isArray(prev) ? prev : [];
      if (current.includes(normalizedId)) {
        return current.filter((id) => id !== normalizedId);
      }
      return [...current, normalizedId];
    });
  };

  const defaultPropsModuleType = {
    options: module,
    getOptionLabel: (option) => `${option.ModuleName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.ModuleName}
            <br />
          </span>
        </li>
      </>
    ),
  };

  //Pjesa per select input field users
  const [userName, setUserName] = useState("");
  const handleAutocompleteChangeUser = (event, value) => {
    if (value && value.Id) {
      setAccountantUserID(value.Id);
      setUserName(value);
    } else {
      // Në rast se vlera është pastruar
      setAccountantUserID(""); // Vendos vlerën e ArticleID në null
    }
  };

  const defaultPropsUser = {
    options: accountantUser,
    getOptionLabel: (option) => `${option.UserName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.UserName}
            <br />
          </span>
        </li>
      </>
    ),
  };

  const handleSubmitLicense = (event) => {
    event.preventDefault();
    setLoading(true);

    const stateData = {
      LicenseTypeID: licenseTypeID,
      PackageID: packageID,
      StartDate: startDate,
      EndDate: endDate,
      Status: statusID,
      PaymentStatus: paymentStatusID,
      Comment: licenseComment,
    };

    axios
      .post(ApiLink.API_URL + "License/newLicense", stateData, {
        headers,
        params: {
          companyID: preselectedCompany?.CompanyID,
          identificationNumber: identificationNumber,
        },
      })
      .then((response) => {
        handleSuccess("Licensa u gjenerua me sukses");
        setLoading(false);
        setDisableForm(true);
        setStep(2); // Move to modules step
      })
      .catch((error) => {
        setLoading(false);
        setDisableForm(false);
        if (error.response) {
          // Server ktheu një përgjigje (jo 2xx)
          if (error.response.data) {
            errorAlert(
              `Gabim nga serveri: ${error.response.status}\n` +
                `Detaje: ${JSON.stringify(error.response.data)}`
            );
          } else {
            errorAlert(`Gabim nga serveri: ${error.response.status}`);
          }
        } else if (error.request) {
          // Request u dërgua, por nuk erdhi përgjigje
          errorAlert("Serveri nuk u përgjigj fare. Kontrollo lidhjen.");
        } else {
          // Error tjetër në konfigurim ose ekzekutim
          errorAlert("Gabim gjatë konfigurimit të kërkesës: " + error.message);
        }
      });
  };

  const handleUpdateCompanyPack = () => {
    const updateData = {
      Pack: packageType,
      PackID: packageID ? Number(packageID) : null,
      Module: Array.isArray(moduleType) ? moduleType.join(",") : moduleType,
      ModuleIds: moduleIDs,
      StartDate: startDate,
      EndDate: endDate,
    };

    // axios.put(ApiLink.API_URL + 'PackContoller', updateData, { headers })
    return axios
      .put(ApiLink.API_URL + "PackContoller/packForCompany", updateData, {
        headers,
        params: {
          companyID: preselectedCompany?.CompanyID,
          identificationNumber: identificationNumber,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setDisableForm(true);
          // handleSuccess(response.data); // Shfaq mesazhin e suksesit
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 400) {
            errorAlert(
              "Të dhënat janë të pavlefshme. Ju lutem kontrolloni dhe provoni përsëri."
            );
          } else if (error.response.status === 500) {
            errorAlert("Gabim serveri. Ju lutem provoni më vonë.");
          } else {
            errorAlert("Gabim i panjohur: " + error.response.data);
          }
        } else {
          errorAlert(
            "Nuk mund të lidhemi me serverin. Ju lutem provoni më vonë."
          );
        }
        throw error;
      });
  };

  const handleSubmitModules = async (event) => {
    event.preventDefault();

    if ((moduleIDs || []).length === 0) {
      if (Number(licenseTypeID) === 5) {
        setStep(3);
      } else {
        setStep(4);
      }
      return;
    }

    setLoading(true);

    try {
      await handleUpdateCompanyPack();
      handleSuccess("Modulet u ruajtën me sukses");

      if (Number(licenseTypeID) === 5) {
        setStep(3); // Move to accountant Form
      } else {
        setStep(4); // Move to final Form
      }
    } catch (error) {
      // Alert is handled in handleUpdateCompanyPack
    } finally {
      setLoading(false);
    }
  };

  const handleSkipModules = () => {
    if (Number(licenseTypeID) === 5) {
      setStep(3);
    } else {
      setStep(4);
    }
  };

  const handleCloseForm = () => {
    history.push("/configuration/licenses");
  };

  const handleSubmitAccountant = (event) => {
    event.preventDefault();
    setLoading(true);

    const stateData = {
      UserID: accountantUserID,
      IPAddress: ipAddress,
      Comment: userComment,
    };

    axios
      .post(ApiLink.API_URL + "License/newFreeManagementAccount", stateData, {
        headers,
        params: {
          companyID: preselectedCompany?.CompanyID,
          identificationNumber: identificationNumber,
        },
      })
      .then((response) => {
        setLoading(false);
        handleSuccess("Llogaria u shtua tek lista e kontabilistit");
        setStep(4); // Move to final Form
      })
      .catch((error) => {
        setLoading(false);
        if (error.response) {
          // Server ktheu një përgjigje (jo 2xx)
          if (error.response.data) {
            errorAlert(
              `Gabim nga serveri: ${error.response.status}\n` +
                `Detaje: ${JSON.stringify(error.response.data)}`
            );
          } else {
            errorAlert(`Gabim nga serveri: ${error.response.status}`);
          }
        } else if (error.request) {
          // Request u dërgua, por nuk erdhi përgjigje
          errorAlert("Serveri nuk u përgjigj fare. Kontrollo lidhjen.");
        } else {
          // Error tjetër në konfigurim ose ekzekutim
          errorAlert("Gabim gjatë konfigurimit të kërkesës: " + error.message);
        }
      });
  };

  useEffect(() => {
    if (isRelicenseMode && preselectedCompany) {
      setCompany([preselectedCompany]);
      setCompanyName(preselectedCompany);
      setIdentificationNumber(preselectedCompany.IdentificationNumber || "");
      return;
    }

    axios
      .get(ApiLink.API_URL + "Companies/companyWithoutLicense", { headers })
      .then((response) => {
        setCompany(response.data);
      })
      .catch((error) => {
        errorAlert("Gabim gjate marrjes se te dhenave");
      });
  }, [disableForm, isRelicenseMode]);

  useEffect(() => {
    const canPrefill =
      isRelicenseMode &&
      preselectedCompany?.CompanyID &&
      !latestLicensePrefilled &&
      licenseTypes.length > 0 &&
      licensesStatus.length > 0 &&
      licensePaymentType.length > 0 &&
      pack.length > 0;

    if (!canPrefill) {
      return;
    }

    const seed = resolvedLicenseSeed;
    if (seed) {
      const seedLicenseTypeID = seed?.LicenseTypeID ?? seed?.licenseTypeID ?? "";
      const seedPackageID = seed?.PackageID ?? seed?.packageID ?? "";
      const seedStatus = seed?.Status ?? seed?.status ?? "";
      const seedPaymentStatus = seed?.PaymentStatus ?? seed?.paymentStatus ?? "";
      const seedStartDate = seed?.StartDate ?? seed?.startDate ?? "";
      const seedEndDate = seed?.EndDate ?? seed?.endDate ?? "";
      const seedComment = seed?.Comment ?? seed?.comment ?? "";

      const matchedLicenseType = licenseTypes.find(
        (item) => String(item.DurationTypeID) === String(seedLicenseTypeID)
      );
      const matchedPackage = pack.find(
        (item) => String(item.PackageID) === String(seedPackageID)
      );
      const matchedStatus = licensesStatus.find(
        (item) => String(item.LicenseStatusID) === String(seedStatus)
      );
      const matchedPaymentStatus = licensePaymentType.find(
        (item) => String(item.PaymentStatusID) === String(seedPaymentStatus)
      );

      setLicenseTypeID(seedLicenseTypeID || "");
      setLiceseType(matchedLicenseType || null);

      setPackageID(seedPackageID || "");
      setPackageField(matchedPackage || null);
      setPackageType(matchedPackage?.PackageName || null);

      setStatusID(seedStatus || "");
      setLiceseStatus(matchedStatus || null);

      setPaymentStatusID(seedPaymentStatus || "");
      setPaymentStatus(matchedPaymentStatus || null);

      const nextStartDate = isRelicenseMode
        ? shiftIsoDateYear(seedStartDate, 1)
        : toIsoDate(seedStartDate);
      const nextEndDate = isRelicenseMode
        ? shiftIsoDateYear(seedEndDate, 1)
        : toIsoDate(seedEndDate);

      setStartDate(nextStartDate);
      setEndDate(nextEndDate);
      setLicenseComment(seedComment || "");
      setLatestLicensePrefilled(true);
      return;
    }

    axios
      .get(`${ApiLink.API_URL}License/latest/${preselectedCompany.CompanyID}`, { headers })
      .then((response) => {
        const latest = response.data;
        if (!latest) {
          setLatestLicensePrefilled(true);
          return;
        }

        const getLatestValue = (...keys) => {
          for (const key of keys) {
            const value = latest?.[key];
            if (value !== undefined && value !== null) {
              return value;
            }
          }
          return "";
        };

        const latestLicenseTypeID = getLatestValue("LicenseTypeID", "licenseTypeID");
        const latestPackageID = getLatestValue("PackageID", "packageID");
        const latestStatus = getLatestValue("Status", "status");
        const latestPaymentStatus = getLatestValue("PaymentStatus", "paymentStatus");
        const latestStartDate = getLatestValue("StartDate", "startDate");
        const latestEndDate = getLatestValue("EndDate", "endDate");
        const latestComment = getLatestValue("Comment", "comment");

        const matchedLicenseType = licenseTypes.find(
          (item) => String(item.DurationTypeID) === String(latestLicenseTypeID)
        );
        const matchedPackage = pack.find(
          (item) => String(item.PackageID) === String(latestPackageID)
        );
        const matchedStatus = licensesStatus.find(
          (item) => String(item.LicenseStatusID) === String(latestStatus)
        );
        const matchedPaymentStatus = licensePaymentType.find(
          (item) => String(item.PaymentStatusID) === String(latestPaymentStatus)
        );

        setLicenseTypeID(latestLicenseTypeID || "");
        setLiceseType(matchedLicenseType || null);

        setPackageID(latestPackageID || "");
        setPackageField(matchedPackage || null);
        setPackageType(matchedPackage?.PackageName || null);

        setStatusID(latestStatus || "");
        setLiceseStatus(matchedStatus || null);

        setPaymentStatusID(latestPaymentStatus || "");
        setPaymentStatus(matchedPaymentStatus || null);

        const nextStartDate = isRelicenseMode
          ? shiftIsoDateYear(latestStartDate, 1)
          : toIsoDate(latestStartDate);
        const nextEndDate = isRelicenseMode
          ? shiftIsoDateYear(latestEndDate, 1)
          : toIsoDate(latestEndDate);

        setStartDate(nextStartDate);
        setEndDate(nextEndDate);
        setLicenseComment(latestComment || "");
        setLatestLicensePrefilled(true);
      })
      .catch(() => {
        errorAlert("Gabim gjatë marrjes së licensës së fundit për relicensim.");
        setLatestLicensePrefilled(true);
      });
  }, [
    isRelicenseMode,
    preselectedCompany,
    latestLicensePrefilled,
    licenseTypes,
    licensesStatus,
    licensePaymentType,
    pack,
    resolvedLicenseSeed,
  ]);

  const fetchUser = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Users/getAccountantUser",
        { headers }
      );
      setAccountantUser(response.data);
      setLoading(false);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);

      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const calculateEndDate = (durationDays) => {
    // startDate është gjithmonë data e sotme
    const start = new Date();

    // endDate = startDate + durationDays
    const end = new Date(start);
    end.setDate(start.getDate() + Number(durationDays));

    // kthe format YYYY-MM-DD
    return end.toISOString().split("T")[0];
  };

  // const calculateEndDate = (type) => {
  //   const today = new Date(startDate);
  //   const end = new Date(today);

  //   switch (type) {
  //     case "trial":
  //     case "weekly":
  //       end.setDate(today.getDate() + 7);
  //       break;
  //     case "monthly":
  //       end.setMonth(today.getMonth() + 1);
  //       break;
  //     case "yearly":
  //     case "accountant":
  //       end.setFullYear(today.getFullYear() + 1);
  //       break;
  //     default:
  //       end.setDate(today.getDate());
  //   }
  //   return end.toISOString().split("T")[0]; // format YYYY-MM-DD
  // };

  useEffect(() => {
    if (isRelicenseMode) {
      return;
    }

    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;

    if (fiscalYear === year) {
      setStartDate(formattedDate);
    } else {
      setStartDate("");
    }
  }, [fiscalYear, isRelicenseMode]);

  useEffect(() => {
    if (module.length > 0 && moduleIDs.length > 0) {
      const selectedModules = module.filter((option) =>
        moduleIDs.includes(Number(option.ModuleID))
      );
      setModuleField(selectedModules);
      setModuleType(selectedModules.map((option) => option.ModuleCode).filter(Boolean));
      return;
    }

    if (moduleIDs.length === 0) {
      setModuleField([]);
      setModuleType([]);
    }
  }, [module, moduleIDs]);

  useEffect(() => {
    const selectedCompanyId = Number(
      preselectedCompany?.CompanyID || companyName?.CompanyID || 0
    );

    if (!selectedCompanyId) {
      return;
    }

    if (step !== 2) {
      return;
    }

    if (String(modulesPrefilledForCompanyId) === String(selectedCompanyId)) {
      return;
    }

    axios
      .get(`${ApiLink.API_URL}Companies/company-setup/${selectedCompanyId}`, { headers })
      .then((response) => {
        const setup = response?.data || {};
        const modulesFromCompany = Array.isArray(setup.Modules) ? setup.Modules : [];

        const activeModuleIds = modulesFromCompany
          .filter((item) => {
            const activeValue = item?.IsActive;
            return (
              activeValue === true ||
              String(activeValue) === "1" ||
              String(activeValue).toLowerCase() === "true"
            );
          })
          .map((item) => Number(item?.ModuleID))
          .filter((id) => Number.isInteger(id) && id > 0);

        setModuleIDs(activeModuleIds);
        setModulesPrefilledForCompanyId(selectedCompanyId);
      })
      .catch(() => {
        setModulesPrefilledForCompanyId(selectedCompanyId);
      });
  }, [
    step,
    preselectedCompany,
    companyName,
    modulesPrefilledForCompanyId,
    headers,
  ]);

  // const fetchPack = async () => {
  //   try {
  //     const response = await axios.get(ApiLink.API_URL + "PackContoller", {
  //       headers,
  //       params: { type: "pako" },
  //     });
  //     setPack(response.data);
  //     setLoading(false);
  //   } catch (error) {
  //     errorAlert("Gabim në kërkesë:", error);

  //     if (
  //       error.response &&
  //       error.response.data &&
  //       error.response.data.errorMessage
  //     ) {
  //       errorAlert(
  //         `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`
  //       );
  //     } else if (error.message) {
  //       errorAlert(`Gabim: ${error.message}`);
  //     } else {
  //       errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
  //     }
  //   }
  // };

  // const fetchModule = async () => {
  //   try {
  //     const response = await axios.get(ApiLink.API_URL + "PackContoller", {
  //       headers,
  //       params: { type: "modul" },
  //     });
  //     setModule(response.data);
  //     setLoading(false);
  //   } catch (error) {
  //     errorAlert("Gabim në kërkesë:", error);

  //     if (
  //       error.response &&
  //       error.response.data &&
  //       error.response.data.errorMessage
  //     ) {
  //       errorAlert(
  //         `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`
  //       );
  //     } else if (error.message) {
  //       errorAlert(`Gabim: ${error.message}`);
  //     } else {
  //       errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
  //     }
  //   }
  // };

  const cleanForm = (e) => {
    e.preventDefault();

    setDisableForm(false);
    setLoading(false);
    setIdentificationNumber("");
    setLicenseTypeID("");
    setPackageID("");
    setStartDate(new Date().toISOString().slice(0, 10));
    setEndDate("");
    setStatusID("");
    setPaymentStatusID("");
    setLicenseComment("");

    setCompanyName("");
    setLiceseType("");
    setLiceseStatus(null);
    setPaymentStatus("");
    setPackageType(null);
    setPackageField(null);
    setModuleType([]);
    setModuleField([]);
    setModuleIDs([]);
    setModulesPrefilledForCompanyId(null);
    setStep(1);
  };

  const loaddata = async () => {
    try {
      const [
        packagesType,
        modules,
        licenseType,
        licenseStatus,
        licensePaymentType,
      ] = await Promise.all([
        getSystemPackage(headers),
        getSystemModules(headers),
        getSystemLicenseTypes(headers),
        getLicenseStatus(headers),
        getLicensePaymentStatus(headers),
      ]);

      if (packagesType) setPack(packagesType);
      if (modules) setModule(modules);
      if (licenseType) setLicenseTypes(licenseType);

      console.log(licenseType);
      if (licenseStatus) setLicensesStatus(licenseStatus);
      if (licensePaymentType) setLicensePaymentType(licensePaymentType);
    } catch (error) {}
  };

  useEffect(() => {
    fetchUser();
    // fetchPack();
    // fetchModule();
    loaddata();
  }, []);

  return (
    <div className={`form-container nlm-page ${isRelicenseMode ? "is-relicense" : ""}`}>
      {/* te dhenat e licenses se kompnanis */}
      {step === 1 && (
        <form className="card nlm-card nlm-card--license" onSubmit={handleSubmitLicense}>
          <div className="nlm-header">
            <h2 className="nlm-title">Hapi 1: {isRelicenseMode ? "Rilicensimi i Kompanisë" : "Gjenerimi i Licensës"}</h2>
            <p className="nlm-subtitle">
              {isRelicenseMode
                ? "Rilicensimi krijon një licensë të re për kompaninë e zgjedhur, pa ndryshuar historikun e licensave ekzistuese."
                : "Këtu mund të gjeneroni licensa vetëm për kompanitë që nuk kanë fare licensë ose nëse licensa e tyre ka skaduar."}
            </p>
          </div>

          <div className="form-grid nlm-grid">
            <div className="form-grid-fields nlm-row">
              <Autocomplete
                className="class__Fields"
                {...defaultPropsCompany}
                id="include-input-in-list"
                includeInputInList
                value={
                  company.find(
                    (option) => String(option?.CompanyID || "") === String(preselectedCompany?.CompanyID || companyName?.CompanyID || "")
                  ) || companyName || null
                }
                isOptionEqualToValue={(option, value) =>
                  String(option?.CompanyID || "") === String(value?.CompanyID || "")
                }
                getOptionLabel={(option) => option.CompanyName || ""}
                onChange={handleAutocompleteChangeCompany}
                autoComplete="off"
                disabled={disableForm || isRelicenseMode}
                // isOptionEqualToValue={(option, value) => option.StateID === value.StateID} // Shto funksionin isOptionEqualToValue
                renderInput={(params) => (
                  <TextField
                    // style={{ width: "95%" }}
                    {...params}
                    label="Zgjedheni kompanin"
                    autoComplete="off"
                    disabled={disableForm}
                    // variant="filled"
                    //   onKeyPress={handleKeyPress}
                  />
                )}
              />

              <Autocomplete
                className="class__Fields"
                {...defaultPropsLicenseType}
                id="include-input-in-list"
                includeInputInList
                value={
                  licenseTypes.find(
                    (option) => String(option?.DurationTypeID || "") === String(licenseTypeID || licenseType?.DurationTypeID || "")
                  ) || licenseType || null
                }
                isOptionEqualToValue={(option, value) =>
                  String(option?.DurationTypeID || "") === String(value?.DurationTypeID || "")
                }
                onChange={handleAutocompleteChangeLicenseType}
                autoComplete="off"
                disabled={disableForm}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Zgjedh Llojin e licenses"
                    autoComplete="off"
                    disabled={disableForm}
                  />
                )}
              />
            </div>
            <div className="form-grid-fields nlm-row">
              <TextField
                className="class__Fields"
                id="date"
                type="date"
                variant="outlined"
                name="Date"
                label="Data fillimit"
                value={startDate}
                disabled={disableForm}
                onChange={(e) => setStartDate(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                // inputProps={{
                //     min: minDate, // Kufizimi minimal i datës
                //     max: maxDate, // Kufizimi maksimal i datës
                // }}
              />

              <TextField
                className="class__Fields"
                id="date"
                type="date"
                variant="outlined"
                name="Date"
                label="Data mbarimit"
                value={endDate}
                disabled={disableForm}
                onChange={(e) => {
                  setEndDate(e.target.value);
                }}
                // disabled={form1IsDisabled}
                InputLabelProps={{
                  shrink: true,
                }}
                // inputProps={{
                //     min: minDate, // Kufizimi minimal i datës
                //     max: maxDate, // Kufizimi maksimal i datës
                // }}
              />
            </div>
            <div className="form-grid-fields nlm-row">
              <Autocomplete
                className="class__Fields"
                {...defaultPropsPackageType}
                id="include-input-in-list"
                includeInputInList
                value={
                  pack.find(
                    (option) => String(option?.PackageID || "") === String(packageID || packageField?.PackageID || "")
                  ) || packageField || null
                }
                isOptionEqualToValue={(option, value) =>
                  String(option?.PackageID || "") === String(value?.PackageID || "")
                }
                disabled={disableForm}
                getOptionLabel={(option) => option.PackageName || ""}
                onChange={handleAutocompleteChangePackageType}
                autoComplete="off"
                // isOptionEqualToValue={(option, value) => option.StateID === value.StateID} // Shto funksionin isOptionEqualToValue
                renderInput={(params) => (
                  <TextField
                    // style={{ width: "95%" }}
                    {...params}
                    label="Zgjedh Llojin e Pakos"
                    autoComplete="off"
                    disabled={disableForm}

                    // variant="filled"
                    //   onKeyPress={handleKeyPress}
                  />
                )}
              />
            </div>
            <div className="form-grid-fields nlm-row">
              <Autocomplete
                className="class__Fields"
                {...defaultPropsLicenseStatus}
                id="include-input-in-list"
                includeInputInList
                // value={licenseStatus}
                isOptionEqualToValue={(option, value) =>
                  String(option?.LicenseStatusID || "") === String(value?.LicenseStatusID || "")
                }
                value={
                  licensesStatus.find(
                    (option) => String(option?.LicenseStatusID || "") === String(statusID || "")
                  ) || licenseStatus
                }
                getOptionLabel={(option) => option.StatusName || ""}
                onChange={handleAutocompleteChangeLicenseStatus}
                autoComplete="off"
                disabled={disableForm}
                // isOptionEqualToValue={(option, value) => option.StateID === value.StateID} // Shto funksionin isOptionEqualToValue
                renderInput={(params) => (
                  <TextField
                    // style={{ width: "95%" }}
                    {...params}
                    label="Statusi i licenses"
                    autoComplete="off"
                    disabled={disableForm}

                    // variant="filled"
                    //   onKeyPress={handleKeyPress}
                  />
                )}
              />

              <Autocomplete
                className="class__Fields"
                {...defaultPropsPaymentStatus}
                id="include-input-in-list"
                includeInputInList
                // value={paymentStatus}
                isOptionEqualToValue={(option, value) =>
                  String(option?.PaymentStatusID || "") === String(value?.PaymentStatusID || "")
                }
                value={
                  licensePaymentType.find(
                    (option) => String(option?.PaymentStatusID || "") === String(paymentStatusID || "")
                  ) || paymentStatus
                }
                getOptionLabel={(option) => option.StatusName || ""}
                onChange={handleAutocompleteChangePaymentStatus}
                autoComplete="off"
                disabled={disableForm}
                // isOptionEqualToValue={(option, value) => option.StateID === value.StateID} // Shto funksionin isOptionEqualToValue
                renderInput={(params) => (
                  <TextField
                    // style={{ width: "95%" }}
                    {...params}
                    label="Statusi i pagesës"
                    autoComplete="off"
                    disabled={disableForm}

                    // variant="filled"
                    //   onKeyPress={handleKeyPress}
                  />
                )}
              />
            </div>
            <label className="nlm-textarea-wrap">
              <span>Përshkrim</span>
              <textarea
                value={licenseComment}
                onChange={(e) => setLicenseComment(e.target.value)}
                placeholder="Shkruani komentin për këtë licensë"
                rows="2"
              />
            </label>
          </div>
          <div className="nlm-actions">
            <button className="nlm-btn nlm-btn--secondary" type="button" onClick={handleCloseForm}>
              Mbyll Formën
            </button>
            <button className="nlm-btn nlm-btn--primary" type="submit" disabled={loading}>
              {loading ? "Duke u procesuar..." : "Ruaj Licensimi"}
            </button>
          </div>
        </form>
      )}
      {step === 2 && (
        <form className="card nlm-card nlm-card--license" onSubmit={handleSubmitModules}>
          <div className="nlm-header">
            <h2 className="nlm-title">Hapi 2: Modulet e Kompanisë</h2>
            <p className="nlm-subtitle">Pas ruajtjes së licensës, caktoni modulet për kompaninë.</p>
          </div>

          <div className="form-grid nlm-grid">
            <div className="form-grid-fields nlm-row">
              <TextField
                className="class__Fields"
                label="Pako e zgjedhur"
                value={packageType || packageField?.PackageName || "-"}
                InputProps={{ readOnly: true }}
              />
              <TextField
                className="class__Fields"
                label="Module aktive"
                value={`${moduleIDs.length} të zgjedhura`}
                InputProps={{ readOnly: true }}
              />
            </div>

            <div className="nlm-modules-grid">
              {(module || []).map((item) => {
                const moduleId = Number(item?.ModuleID);
                const checked = moduleIDs.includes(moduleId);

                return (
                  <label
                    key={item?.ModuleID || item?.ModuleName}
                    className={`nlm-module-card ${checked ? "is-checked" : ""}`}
                  >
                    <input
                      type="checkbox"
                      checked={checked}
                      onChange={() => handleToggleModule(moduleId)}
                    />
                    <span className="nlm-module-name">{item?.ModuleName || "Pa emër"}</span>
                  </label>
                );
              })}

              {(module || []).length === 0 && (
                <div className="nlm-module-empty">Nuk ka module aktive në sistem.</div>
              )}
            </div>
          </div>

          <div className="nlm-actions">
            <button
              className="nlm-btn nlm-btn--secondary"
              type="button"
              onClick={handleSkipModules}
            >
              Skip Modulet
            </button>
            <button className="nlm-btn nlm-btn--secondary" type="button" onClick={handleCloseForm}>
              Mbyll Formën
            </button>
            <button className="nlm-btn nlm-btn--primary" type="submit" disabled={loading}>
              {loading ? "Duke u procesuar..." : "Ruaj Modulet"}
            </button>
          </div>
        </form>
      )}
      {/* te dhenat per kontabilist */}
      {step === 3 && (
        <form className="card nlm-card nlm-card--accountant" onSubmit={handleSubmitAccountant}>
          <div className="nlm-header">
            <h2 className="nlm-title">Informata për kontabilistin</h2>
            <p className="nlm-subtitle">Plotëso të dhënat shtesë për konfigurimin e llogarisë së kontabilistit.</p>
          </div>

          <div className="form-grid nlm-grid">
            <div className="form-grid-fields nlm-row">
              <Autocomplete
                className="class__Fields"
                {...defaultPropsUser}
                id="include-input-in-list"
                includeInputInList
                value={userName}
                getOptionLabel={(option) => option.UserName || ""}
                onChange={handleAutocompleteChangeUser}
                autoComplete="off"
                // isOptionEqualToValue={(option, value) => option.StateID === value.StateID} // Shto funksionin isOptionEqualToValue
                renderInput={(params) => (
                  <TextField
                    // style={{ width: "95%" }}
                    {...params}
                    label="Zgjedh përdoruesin"
                    autoComplete="off"

                    // variant="filled"
                    //   onKeyPress={handleKeyPress}
                  />
                )}
              />

              <TextField
                className="class__Fields"
                id="outlined-required"
                label="IP Adresa"
                value={ipAddress}
                onChange={(event) => setIpAddress(event.target.value)}
                autoComplete="off"
              />
            </div>
            <label className="nlm-textarea-wrap">
              <span>Përshkrim</span>
              <textarea
                value={userComment}
                onChange={(e) => setUserComment(e.target.value)}
                placeholder="Shto koment për llogarinë e kontabilistit"
                rows="2"
              />
            </label>
          </div>
          <div className="nlm-actions">
            <button className="nlm-btn nlm-btn--secondary" type="button" onClick={handleCloseForm}>
              Mbyll Formën
            </button>
            <button className="nlm-btn nlm-btn--primary" type="submit" disabled={loading}>
              {loading ? "Duke u procesuar..." : "Ruaj"}
            </button>
          </div>
        </form>
      )}
      {/* perfundimi */}
      {step === 4 && (
        <form className="card nlm-card nlm-card--success" onSubmit={handleSubmitLicense}>
          <div className="nlm-success-message">
            <h2 className="nlm-title">Licensa u ruajt me sukses</h2>
            <p className="nlm-subtitle">Mund të krijoni një licensë të re duke përdorur butonin më poshtë.</p>
          </div>
          <div className="nlm-actions">
            <button className="nlm-btn nlm-btn--secondary" type="button" onClick={handleCloseForm}>
              Mbyll Formën
            </button>
            <AddActionsButton
              text="Krijo licens të re"
              icon={<FaTimes />}
              className="nlm-btn nlm-btn--secondary"
              onClick={(e) => cleanForm(e)}
            />
          </div>
        </form>
      )}
    </div>
  );
}
